<template>
  <b-modal
    id="selectappquery.modal"
    ref="selectappquery.modal"
    v-model="modal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #default="{ hide }">
      <div>
        <div class="card custom-bg border-0">
          <div class="card-header border-0 p-2">
            <div class="w-100 text-center">
              <span class="text-monospace">Query Recommendation</span>
              <b-icon
                icon="x-circle"
                scale="1"
                variant="danger"
                @click="hide()"
                class="card-tools float-right"
              ></b-icon>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group text-center">
              <b class="text-center"
                >{{ application.surname }} {{ application.firstname }}
                {{ application.lastname }}</b
              >
              <br />
              <label>{{ application.application_number }}</label>
            </div>
            <div class="form-group">
              <label>Message to department</label>
              <textarea
                class="form-control form-control-lg small-font"
                rows="5"
                :class="{ 'is-invalid': errors.query_reason }"
                v-model="query_reason"
              >
              </textarea>
              <div v-if="errors.query_reason" class="text-danger">
                {{ errors.query_reason }}
              </div>
            </div>
            <div class="d-block m-2">
              <button
                class="btn btn-sm btn-primary"
                @click="query_recommendation"
              >
                Send Query
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      query_reason: "",
      application: "",
      errors: {},
    };
  },
  methods: {
    query_recommendation() {
      this.errors = {}; // Reset errors
      if (!this.query_reason) {
        this.errors.query_reason =
          "Kindly provide reason(s) for querying this recommendation";
      } else {
        this.$store.dispatch("spinner/showSpinner");
        axios
          .post("admin/pg_comment_for_department", {
            query_msg: this.query_reason,
            applicationId: this.application.id,
          })
          .then((response) => {
            console.log(response);
            Toast.fire({
              icon: "info",
              title: "Querying Recommendation",
            });
            Fire.$emit("acceptAdmission");
            this.modal = false;
            this.$store.dispatch("spinner/hideSpinner");
          })
          .catch((err) => {
            Toast.fire({
              icon: "info",
              title: err.response?.data?.message,
            });
            this.$store.dispatch("spinner/hideSpinner");
          });
      }
    },
  },
  created() {
    Fire.$off("queryApplication");
    Fire.$on("queryApplication", (data) => {
      this.application = data;
      this.modal = true;
    });
  },
};
</script>

<style></style>
